import styled from "styled-components"

const SearchButton = styled.button`
  background-color: ${(props) => props.theme.a_color_gradients.a_dark};
`

const NotificationButton = styled.button`
  background-color: ${(props) => props.theme.a_color_gradients.a_dark};
`

const Container = styled.div`
  background-color: ${(props) => props.theme.a_color_gradients.a_dark};
`

export { SearchButton, NotificationButton, Container }
